import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/contexts/authStore';
import { Loader2 } from 'lucide-react';
import { useEffect } from 'react';
import { setRecommendedPlan, getRecommendedPlan, setShowPlanModal } from '@/lib/recommendedPlan';

/**
 * GuestRoute - Inverse of ProtectedRoute
 * Redirects authenticated users to dashboard while preserving recommended_plan
 */
export default function GuestRoute() {
  const { user, loading } = useAuthStore();
  const [searchParams] = useSearchParams();

  // Salvar plano da URL de forma síncrona (antes de qualquer redirect)
  const planFromUrl = searchParams.get('recommended_plan');
  if (planFromUrl) {
    setRecommendedPlan(planFromUrl);
  }

  // Persist recommended_plan from URL for non-logged users too
  useEffect(() => {
    if (planFromUrl) {
      setRecommendedPlan(planFromUrl);
    }
  }, [planFromUrl]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  // If user is logged in, redirect to dashboard
  if (user) {
    // Verificar se há plano na URL ou no sessionStorage
    const recommendedPlan = planFromUrl || getRecommendedPlan();
    if (recommendedPlan) {
      // Setar flag para mostrar modal no dashboard
      setShowPlanModal(true);
    }
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
